<script>
  export let store;
  export let storeLabel;

  let minimized;

  function safeStringify(obj, indent = 2) {
    let cache = [];
    const retVal = JSON.stringify(
      obj,
      (key, value) =>
        typeof value === 'object' && value !== null
          ? cache.includes(value)
            ? undefined // Duplicate reference found, discard key
            : cache.push(value) && value // Store value in our collection
          : value,
      indent
    );
    cache = null;
    return retVal;
  }
</script>

{#if store}
  <span
    class="
    text-xs font-lexend font-normal border dark:border-dark-60 p-1 flex flex-row justify-between items-start"
  >
    <span>
      <button
        class="font-light text-sm bg-stone-200 dark:bg-dark-70 px-2"
        on:dblclick={() => {
          console.log($store);
        }}
        on:click={() => {
          minimized = !minimized;
        }}
        >{storeLabel}
      </button>
      <span class="text-xs bg-stone-200 dark:bg-dark-60 px-2">{typeof $store} </span>
      <span class="block border dark:border-dark-60">
        {$store}
      </span>
    </span>
    {#if !minimized}
      <pre
        class="block border dark:border-dark-60 overflow-scroll
      max-w-[70vw] min-w-[70vw] min-h-[5vh] max-h-[40vh]">
{safeStringify($store)}
    </pre>
    {/if}
  </span>
{:else}
  <span class="text-xs font-lexend font-normal bg-red-50 border p-1 dark:border-dark-60">
    {storeLabel} : No store
  </span>
{/if}
